import SAAdminLayout from "../../../layouts/Sinfodemanager"; // Assuming you have a layout component for the admin dashboard



export default function Invoices() {
  
  return (
    <SAAdminLayout>
      <div className="p-6">
     <h1 className="text-2xl font-bold mb-6">Invoice</h1>
      </div>
    </SAAdminLayout>
  );
}
